module.exports = __webpack_public_path__ + "img/dokumen_diterima.864c9570.png";